module.exports = __webpack_public_path__ + "static/la1.ce86f5b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/gallery/la1.jpg
// module id = 537
// module chunks = 27362984104999